import { Button, Icon } from '@digitools/honest-react';
import React, { useRef } from 'react';
import useExperience from 'src/hooks/useExperience';
import { Language } from 'src/types/Language';
import styled from 'styled-components';
import { DocumentUploadDisplayTextEn } from './language/DocumentUploadDisplayTextEn';
import { DocumentUploadDisplayTextEs } from './language/DocumentUploadDisplayTextEs';
const StyledFileInput = styled('input') `
  display: none;
`;
const UploadButton = ({ onUpload, eventNum }) => {
    const { language } = useExperience();
    const fileInputRef = useRef(null);
    const languageFile = language === Language.SPANISH ? DocumentUploadDisplayTextEs : DocumentUploadDisplayTextEn;
    return (<Button type={'button'} style={{ marginLeft: '.5rem', fontSize: '16px', fontWeight: 'bold' }} data-testid={'uploadButton'} onClick={() => { fileInputRef.current?.click(); }}>
      <Icon color={'secondary'} name={'upload'} size={'medium'} style={{ marginRight: '0.5rem' }}/>
      {languageFile.uploadButtonText}
      <StyledFileInput ref={fileInputRef} data-testid={'fileUpload' + eventNum} type={'file'} id={'file-upload' + eventNum} onChange={onUpload} accept={'.gif, .jpg, .pdf, .pptx, .tif, .tiff, .xls, .xlsx, .doc, .docx'}/>
    </Button>);
};
export default UploadButton;
